import { LoadingButton } from '@mui/lab';
import { Checkbox, TextField, InputAdornment, Button, FormGroup, FormControlLabel, AppBar, Box, IconButton, Toolbar, Typography, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Tabs, Tab, Autocomplete, Paper, Stepper, Step, StepLabel, MenuItem, Alert, Snackbar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Menu, Avatar, Divider, Popover, Switch, Tooltip } from '@mui/material';

const Components = {
  Avatar,
  TextField,
  Divider,
  Autocomplete,
  InputAdornment,
  Button,
  Checkbox,
  FormGroup, FormControlLabel,
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tabs,
  Tab,
  Paper,
  Stepper,
  Step,
  StepLabel,
  MenuItem,
  Alert,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LoadingButton,
  Menu,
  Popover,
  Switch,
  Tooltip
};

export default Components;
